import React, { Component } from 'react';

export default class Layout extends Component {

    render(){
        return (
            <div className='app-container'>
                {this.props.children}
            </div>
        );
    }

}





/** WEBPACK FOOTER **
 ** ./src/components/Layout.js
 **/